(function () {
  'use strict';
  angular.module('dso')
    .component('dsoLocation', {
        bindings: {
          taxIdListMax: '@',
          model: '=',
          editable: '@',
          serviceUnavailable: '=',
          isRunning: '=',
          locations: '=',
          removedLocation: '<',
          resetOnFiltering: '<'
        },
        controllerAs: 'vm',
        require: {
            form: '^form'
        },
        controller: ['dsoProviderService', '$scope', '$filter', 'Dso', 'uiGridConstants',  function(dsoProviderService,$scope, $filter, Dso, uiGridConstants) {
          var vm = this;
          vm.prev = {'taxId':undefined, 'city': undefined, 'state': undefined};
          vm.running = false;
          vm.showGrid = false;
          vm.showTaxIdSelect = true;
          vm.addLocationColumns = [{name: 'Location',  width: "70%", sortingAlgorithm: sortByFirstRow,
                         cellTemplate: '<div class="ui-grid-cell-content" style="font-size: 12px; text-transform: none;"><b>'+
                                        '{{row.entity | location}}</b>' +
                                        '</div>'},
                        {field: 'Add',  width: "20%", enableSorting: false,
                         headerCellTemplate: '<div class="ui-grid-cell-content" style="font-size: 12px; text-transform: none; text-align: center">Add</div>',
                         cellTemplate: '<div class="ui-grid-cell-content"  style="font-size: 12px; text-transform: none; text-align: center">'+
                         '<a href ng-click="grid.appScope.addLocation(row)" style="color: green;"><i class="fa fa-plus-circle fa-lg" aria-hidden="true" title="Add"></i></a>'+
                         '</div>'}
           ];

           vm.selectLocationColumns = [
                         {field: "location", width: "70%", sortingAlgorithm: sortByFirstRow,
                          headerCellTemplate: '<div class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"><span class="required-content"><label>Locations</label></span></div>',
                          cellTemplate: '<span style="font-size: 12px; text-transform: none;"><b>'+
                                         '{{row.entity | location}}</b>' +
                                         '</span>'},
                         {field: "selected", width: "20%", enableSorting: false,
                          headerCellTemplate: '<div class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"></div>',
                          cellTemplate: '<div class="ui-grid-cell-content" style="font-size: 12px; text-transform: none;" align="left">'+
                          '<input type="checkbox" id="chk{{row.entity.taxId}}{{row.entity.centerId}}" name="location" ng-model="row.entity.selected" ng-click="grid.appScope.selectLocation(row)"'+
                          '</div>',
                          footerCellTemplate: '<div class="ui-grid-cell-contents" style="font-size: 12px; font-weight: bold" ng-show="grid.appScope.getTotalSelected()">Total Selected: {{grid.appScope.getTotalSelected()}}</div>' }
          ];

          vm.rowTemplate = function() {
             return '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"'  +
                 'class="ui-grid-cell" style="height: 35px;"'+
                 'ng-class="{\'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell></div>';
          };

          vm.dsoTaxIdLocationGridOptions = {
                enableSorting: true,
                enableColumnMenus: false,
                rowTemplate: vm.rowTemplate(),
                appScopeProvider: {
                  addLocation : (row) => {
                    _.remove(vm.dsoTaxIdLocationGridOptions.data, (location) => {
                      return row.entity.centerId === location.centerId;
                    });
                    vm.locations.push(row.entity);
                  },
                  selectLocation : (row) => {
                    var centerIdFound =   vm.locations.indexOf(row.entity.centerId);
                    if(centerIdFound === -1) {
                       vm.locations.push(row.entity.centerId);
                    } else {
                       vm.locations.splice(centerIdFound, 1);
                    }
                 },
                 getTotalSelected: () => {
                   return vm.model.taxId ? vm.locations.length : '';
                 }
                },
            onRegisterApi: function(api) {
              vm.gridApi = api;
            }
          };

          this.$onInit = function() {
            vm.init = true;
            vm.model = vm.model == undefined ? {} : vm.model;
            vm.prev.taxId = vm.model.taxId;
            vm.prev.city = vm.model.city;
            vm.prev.state = vm.model.state;
            vm.locations = vm.locations == undefined ? [] : vm.locations;
            vm.locations = angular.isArray(vm.locations) ? vm.locations : [vm.locations];
            vm.taxIdListMax = vm.taxIdListMax == undefined ? 21 : vm.taxIdListMax;
            customizeGrid();
            $scope.$watch('vm.running',function(){
              vm.isRunning = vm.running;
            });
            vm.running= true;
            Dso.getDsoTaxIds().$promise.then((data) => {
              vm.running= false;
              if(data.length) {
                vm.dsoTaxIds = data;
                vm.approvedDsoTaxIds = $filter('filter')(vm.dsoTaxIds, {status: 'APPROVED'});
                vm.showTaxIdSelect = !vm.editable || (vm.approvedDsoTaxIds && vm.approvedDsoTaxIds.length < vm.taxIdListMax);
                vm.approvedTaxIds = _.map(vm.approvedDsoTaxIds,'taxId');
                if (vm.showTaxIdSelect) {
                  vm.getTaxIdLocations();
                }else{
                  watchTaxIdChange();
                }
              }
            },
            (error) => {
              vm.running= false;
            });
          };

          this.$doCheck = function() {
              if (vm.model.taxId !== vm.prev.taxId) {
            	  vm.prev.taxId = vm.model.taxId;
                if (vm.showTaxIdSelect) {
                    if (!vm.editable && !vm.init) {
                      resetSelectedLocations();
                    }
            	     vm.getTaxIdLocations();
                }
              }
              if (vm.resetOnFiltering) {
                if (!vm.init && vm.prev.city !== vm.model.city) {
                  vm.prev.city = vm.model.city;
                  resetSelectedLocations();
                }
                if (!vm.init && vm.prev.state !== vm.model.state) {
                  vm.prev.state = vm.model.state;
                  resetSelectedLocations();
                }
              }
          };

          this.$onChanges = function(changes) {
            if (changes.removedLocation.currentValue && vm.editable) {
              handleLocationRemoval();
            }
          };

          function customizeGrid() {
            vm.dsoTaxIdLocationGridOptions.columnDefs = vm.editable ? vm.addLocationColumns : vm.selectLocationColumns;
            if (!vm.editable) {
                vm.dsoTaxIdLocationGridOptions.showColumnFooter = true;
            }
            vm.showGrid = true;
          }

          function watchTaxIdChange() {
        	   $scope.$watch('vm.model.taxId', function(taxId) {
              if (taxId && vm.form && vm.form.taxId && vm.form.taxId.$valid) {
                vm.getTaxIdLocations();
              } else {
                resetDsoTaxIdLocationsGrid();
              }
            });
          }

          vm.getTaxIdLocations = function() {
            if (vm.model.taxId) {
              if (!vm.init) {
                vm.model.state = '';
                vm.model.city = '';
              }
              vm.running = true;
              dsoProviderService.getTaxIdLocations(vm.model.taxId).then((result) => {
                vm.running = false;
                if (result.serviceUnavailable) {
                  vm.serviceUnavailable = true;
                  return;
                }
                if(result) {
                  vm.dsoTaxIdLocations =  result.locations;
                  if(vm.dsoTaxIdLocations && vm.dsoTaxIdLocations.length) {
                    vm.dsoTaxIdLocationGridOptions.data = _.cloneDeep(vm.dsoTaxIdLocations);
                    removeAddedFromFilteredLocations(vm.dsoTaxIdLocationGridOptions.data);
                    vm.getStates();
                    if (vm.model.state) {
                      vm.filterByState();
                      vm.filterByCity();
                    }else{
                      vm.model.cities = [];
                    }
                    vm.init = false;
                  }
                }
              }, (error) => {
                  vm.running = false;
              });
            } else {
              resetDsoTaxIdLocationsGrid();
            }
          };

          function resetDsoTaxIdLocationsGrid() {
            vm.dsoTaxIdLocationGridOptions.data = [];
            vm.model.cities = [];
            vm.model.states = [];
          }

          function resetSelectedLocations() {
              vm.locations = [];
              removeAddedFromFilteredLocations(vm.dsoTaxIdLocationGridOptions.data);
          }

          vm.getStates = function() {
            vm.model.states = _.map(_.unionBy(vm.dsoTaxIdLocations, 'state'), 'state');
          };

          vm.filterByCity = function() {
            if(vm.model.city) {
              let locationsFilteredByCity = $filter('filter')(vm.dsoTaxIdLocations,{city:vm.model.city});
              if (locationsFilteredByCity && locationsFilteredByCity.length) {
                 vm.dsoTaxIdLocationGridOptions.data = removeAddedFromFilteredLocations(locationsFilteredByCity);
              }else{
                 vm.dsoTaxIdLocationGridOptions.data = locationsFilteredByCity;
              }
            }
          };

          vm.filterByState = function() {
              let locationsFilteredByState = $filter('filter')(vm.dsoTaxIdLocations,{state:vm.model.state});
              if (locationsFilteredByState && locationsFilteredByState.length) {
                 vm.dsoTaxIdLocationGridOptions.data = removeAddedFromFilteredLocations(locationsFilteredByState);
              }else{
                 vm.dsoTaxIdLocationGridOptions.data = locationsFilteredByState;
              }
              if (vm.model.state) {
                vm.model.cities = _.map(_.unionBy(vm.dsoTaxIdLocationGridOptions.data, 'city'), 'city');
              } else {
                vm.model.city = "";
                vm.model.cities = [];
              }
          };

          function removeAddedFromFilteredLocations(filteredLocations) {
              if (vm.editable) {
                _.remove(filteredLocations, (location) => {
                  return !!_.find(vm.locations, (currentLocation) => {
                    return currentLocation.centerId === location.centerId && currentLocation.taxId === vm.model.taxId;
                  });
                });
              }else{
                _.each(filteredLocations,function(location) {
                    location.selected = vm.locations.indexOf(location.centerId) > -1;
                });
              }
              return _.sortBy(filteredLocations,['address1','address2','city','state','zip5']);
          }

          function handleLocationRemoval() {
            if((vm.model.state && vm.model.state === vm.removedLocation.state) && !vm.model.city) {
              vm.dsoTaxIdLocationGridOptions.data.push(vm.removedLocation);
            }
            if((vm.model.state && vm.model.state === vm.removedLocation.state) &&
              (vm.model.city &&  vm.model.city === vm.removedLocation.city)) {
                vm.dsoTaxIdLocationGridOptions.data.push(vm.removedLocation);
            }
            if(!vm.model.state && !vm.model.city && vm.model.taxId === vm.removedLocation.taxId) {
              vm.dsoTaxIdLocationGridOptions.data.push(vm.removedLocation);
            }
            vm.removedLocation = undefined;
          }

          function sortByFirstRow(a, b, rowA, rowB) {
              // if(!rowA.entity.addUserMode) {
                   if (a === b) return 0;
                   if (a < b) return -1;
                   return 1;
              // }
           }

        }],
        templateUrl: '/js/dso/dsoLocation.html' + appVersion
      }
    );
})();
